import { loadStripe } from '@stripe/stripe-js';
import { getCheckoutSession } from '../../api';
import { CheckoutElementsProvider, PaymentElement } from '@stripe/react-stripe-js/checkout';
import CheckoutForm from './CheckoutForm';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY!);

interface CheckoutProps {
    clientSecret: string;
    handleClose: () => void;
    show: boolean;
}

const Checkout = ({ clientSecret, show, handleClose }: CheckoutProps) => {
    return (
        <CheckoutElementsProvider stripe={stripePromise} options={{ clientSecret: clientSecret }}>
            <CheckoutForm show={show} handleClose={handleClose} />
        </CheckoutElementsProvider>
    );
};

export default Checkout;
